/** The mascot. The face and the ink outline only render in the kids skin. */
export function Lantern({ width = 56, height = 78 }: { width?: number; height?: number }) {
  return (
    <svg
      className="bob"
      width={width}
      height={height}
      viewBox="0 0 66 92"
      style={{ filter: 'var(--ink-drop)' }}
      aria-hidden="true"
      focusable="false"
    >
      <path d="M33 4v7" stroke="var(--accent-ink)" strokeWidth="2.4" strokeLinecap="round" />
      <path d="M20 13h26l-3 6H23l-3-6Z" fill="var(--accent-ink)" />
      <path
        d="M23 19h20c6 8 8 16 8 24s-4 17-18 17-18-9-18-17 2-16 8-24Z"
        fill="var(--accent-12)"
        stroke="var(--accent-ink)"
        strokeWidth="2"
      />
      <g className="cartoon-only">
        <circle cx="28" cy="38" r="2.4" fill="var(--outline)" />
        <circle cx="38" cy="38" r="2.4" fill="var(--outline)" />
        <path
          d="M28.5 45.5q4.5 4 9 0"
          fill="none"
          stroke="var(--outline)"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
      <g className="adult-only">
        <path
          d="M33 30l4.4 7.6h-8.8L33 30Zm0 24l-4.4-7.6h8.8L33 54Zm11-12l-7.6 4.4v-8.8L44 42Zm-22 0l7.6-4.4v8.8L22 42Z"
          fill="var(--accent-ink)"
        />
      </g>
      <path d="M18 60h30l-4 6H22l-4-6Z" fill="var(--accent-ink)" />
    </svg>
  );
}

export function Crescent({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      style={{ filter: 'var(--ink-drop)' }}
      aria-hidden="true"
      focusable="false"
    >
      <path d="M21.5 4.2a11 11 0 1 0 4.3 12.6A8.6 8.6 0 0 1 21.5 4.2Z" fill="var(--primary)" />
    </svg>
  );
}

export function StarBadge({ size = 30 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 34"
      style={{ filter: 'var(--ink-drop)', flexShrink: 0 }}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M17 2.5l3.6 7.6 8.4 1-6.1 5.9 1.5 8.3L17 21.4l-7.4 3.9 1.5-8.3-6.1-5.9 8.4-1L17 2.5Z"
        fill="var(--q4)"
        stroke="var(--outline)"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    </svg>
  );
}
